// @flow
import React from 'react';
import {TextInput} from 'sail/Input';
import {CompactTooltip} from 'sail/Tooltip';
import {CaptionMono} from 'sail/Text';
import {dimensions} from '../StyleHelpers';

type StringInputProps = {|
  field_id: string,
  param_key: string,
  required: boolean,
  description: string,
  inputType: string,
  params: Object,
  setParams: (Object) => void,
|};

const handleParamChange = (param_key, value, params, setParams) => {
  if (value) {
    setParams({...params, [param_key]: value});
  } else {
    const {[param_key]: removed, ...newParams} = params;
    setParams(newParams);
  }
};

export const StringInput = ({
  field_id,
  param_key,
  required,
  description,
  inputType,
  params,
  setParams,
}: StringInputProps) => {
  const context = (
    <TextInput
      style={{height: dimensions.height}}
      width={dimensions.width}
      radius="none"
      key={field_id}
      id={field_id}
      onChange={(value) =>
        handleParamChange(param_key, value, params, setParams)
      }
      end={{
        'aria-label': `${inputType}`,
        content: (
          <CaptionMono color="gray" wrap={false}>{`${inputType}`}</CaptionMono>
        ),
      }}
      value={params[param_key]}
    />
  );
  return description ? (
    <CompactTooltip context={context} label={description} position="right" />
  ) : (
    context
  );
};
